import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Auth.css';

function GuestLanding() {
  const navigate = useNavigate();
  const location = useLocation();

  // Get state passed from GuestMeetingRoom
  const { inviteToken, guestName, meetingTitle } = location.state || {};

  const handleRejoin = () => {
    if (inviteToken) {
      // Navigate to the invite page to rejoin
      navigate(`/invite/${inviteToken}`);
    } else {
      // Fallback - just show a message
      alert('Unable to rejoin. Please use the original invite link.');
    }
  };

  return (
    <div className="auth-container">
      <motion.div
        className="auth-box guest-landing-box"
        initial={{ opacity: 0, y: 20, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="auth-header">
          <div className="brand-icon">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5z"/><path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/></svg>
          </div>
          <h1>VoiceMeet Pro</h1>
          <h2>Thanks for Joining!</h2>
        </div>

        <div className="guest-landing-content">
          <p>👋 You have left the meeting{meetingTitle ? `: ${meetingTitle}` : ''}.</p>
          <p>Thank you for using VoiceMeet Pro{guestName ? `, ${guestName}` : ''}!</p>

          <div className="guest-landing-actions">
            {inviteToken && (
              <>
                <motion.button
                  onClick={handleRejoin}
                  className="btn-secondary"
                  whileHover={{ scale: 1.01 }}
                  whileTap={{ scale: 0.98 }}
                >
                  ← Rejoin Meeting
                </motion.button>

                <div className="divider">
                  <span>or</span>
                </div>
              </>
            )}

            <p className="cta-text">Want to host your own meetings?</p>
            <motion.button
              onClick={() => navigate('/')}
              className="btn-primary"
              whileHover={{ scale: 1.01 }}
              whileTap={{ scale: 0.98 }}
            >
              🚀 Create Free Account
            </motion.button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default GuestLanding;
